import { render, staticRenderFns } from "./PreviewLayout.vue?vue&type=template&id=13034e83&"
import script from "./PreviewLayout.vue?vue&type=script&lang=js&"
export * from "./PreviewLayout.vue?vue&type=script&lang=js&"
import style0 from "./PreviewLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
